export const styles = {
  button: {
    width: 40,
    height: 40
  }
};
